module.exports = __webpack_public_path__ + "img/gallery.989e7aee.png";